/**
 * Entrega o arquivo ao navegador.
 *
 * O `.xlsx` vem atrás de autenticação, então ele chega como blob e não como link — um `<a href>`
 * apontando para a API voltaria 401, porque o navegador não manda o cabeçalho de sessão numa
 * navegação. O objeto de URL é revogado logo depois: ele segura o arquivo inteiro em memória.
 */
export function salvar(blob: Blob, nome: string) {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = nome
  document.body.appendChild(link)
  link.click()
  link.remove()
  URL.revokeObjectURL(url)
}
